<template>
	<div class="dataOriginBox">
		<div class="data_box">
			<div class="dataTitle">
				<span class="must">*</span>
				<span>数据源类型</span>
			</div>
			<div class="dataFileList">
				<el-radio-group v-model="radio" @change="radioChange">
					<el-radio :label="1">Excel文件</el-radio>
					<el-radio :label="2">文本文件</el-radio>
					<el-radio :label="3">CSV文件</el-radio>
				</el-radio-group>
			</div>
		</div>
		<div class="data_box" v-if="radio == 2">
			<div class="dataFileList">
				<el-radio-group v-model="keyType" @change="keyTypeChange">
					<el-radio :label="1">分号</el-radio>
					<el-radio :label="2">Tab键</el-radio>
					<el-radio :label="3">逗号</el-radio>
					<el-radio :label="4">空格</el-radio>
					<el-radio :label="5">
						其他&nbsp;&nbsp;
						<el-input size="medium" v-if="keyType == 5" v-model="input" placeholder="请输入内容"></el-input>
					</el-radio>
				</el-radio-group>
			</div>
		</div>

		<div class="data_box">
			<div class="dataTitle">
				<span class="must">*</span>
				<span>数据源类型</span>
			</div>
			<div class="dataUpladFileList" v-if="file.name == undefined">
				<el-upload
					class="upload-demo"
					drag
					:action="action"
					multiple
					:show-file-list="false"
					:on-success="handleSuccess"
					name="multipartFile"
					:accept="fileAccept"
					:with-credentials="true"
					:data="QiniuData"
				>
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">点击文件到此区域进行上传...</div>
				</el-upload>
			</div>
			<div v-else class="fileBox">
				<div class="fileName">{{ file.name }}</div>
				<div class="fileBtn">
					<el-popconfirm title="确定删除吗？" @confirm="delFile"><el-button type="text" slot="reference">删除</el-button></el-popconfirm>
					<!-- <el-button type="danger" icon="el-icon-delete" circle></el-button> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		file: {
			type: Object
		}
	},
	data() {
		return {
			input: '',
			keyType: 1,
			fileAccept: '.xls,.xlsx',
			action: '',
			radio: 1,
			fileList: [],
			QiniuData: {
				Authorization: ''
			}
		};
	},
	created() {
		this.action = this.$config.service.uploadFiles;
		let token = window.localStorage.getItem('token');
		this.QiniuData.Authorization = token ? 'Bearer ' + token : '';
		console.log(this.file.name);
	},
	mounted() {
		console.log(this.file);
	},
	methods: {
		delFile() {
			this.$emit('uploadfileOk', {});
			this.$emit('uploadOk', '');
			console.log(this.file);
		},
		keyTypeChange(value) {
			let text = value;
			if (value == 5) {
				text = this.value;
			}
			this.$emit('radiokeyType', text);
		},
		radioChange(value) {
			if (value == 1) {
				this.fileAccept = '.xls,.xlsx';
			} else if (value == 2) {
				this.fileAccept = '.txt';
			} else if (value == 3) {
				this.fileAccept = '.csv';
			}
		},
		handleSuccess(response, file, fileList) {
			console.log('上传', response, file, fileList);
			if (response.code == 0) {
				this.$emit('uploadfileOk', file);
				this.$emit('uploadOk', response.resultBody);
				this.$message.success(response.message);
			} else {
				this.$message.error(response.message);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.dataOriginBox {
	width: 72%;
	margin: 20px auto;
	.data_box {
		margin-bottom: 20px;
		.dataTitle {
			height: 20px;
			display: flex;
			margin-bottom: 20px;
			.must {
				// background-color: rgba(255, 4, 4, 1);
				color: rgba(255, 4, 4, 1);
				margin-right: 6px;
				font-size: 20px;
				text-align: center;
			}
		}
		.dataUpladFileList {
			width: 700px;
			height: 200px;
			/deep/.el-upload-dragger {
				width: 700px;
				height: 200px;
			}
		}
		.fileBox {
			width: 660px;
			height: 40px;
			line-height: 40px;
			display: flex;
			justify-content: space-between;
			border: 1px solid #ccc;
			padding: 0px 20px;
			border-radius: 4px;
		}
	}
}
</style>
